export const SITE_URL = 'https://www.salamatlab.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/logo.png`;
export const SYSTEM_NOINDEX_PATTERNS = [
    /^\/auth(?:\/|$)/i,
    /^\/profile(?:\/|$)/i,
    /^\/admin(?:\/|$)/i,
    /^\/r(?:\/|$)/i,
    /^\/wp-login\.php$/i,
];
export const EMPTY_CATEGORY_PATHS: string[] = [];
export type SeoEntry = {
    title: string;
    description: string;
    keywords?: string;
    ogImage?: string;
    noindex?: boolean;
};
const entries: Record<string, SeoEntry> = {
    '/': {
        title: 'آزمایشگاه تشخیص پزشکی سلامت | بهترین پزشکان شهرقدس | آزمایش آنلاین',
        description: 'آزمایشگاه تشخیص پزشکی سلامت - بهترین پزشکان متخصص در شهرقدس. خدمات آزمایشگاهی، نمونه‌گیری در منزل، نوبت آنلاین پزشکان اورولوژی، ارتوپدی، زنان و زایمان',
        keywords: 'آزمایشگاه سلامت, پزشک شهرقدس, آزمایش خون, نمونه‌گیری در منزل, پزشک اورولوژی شهرقدس, پزشک ارتوپدی قدس, آزمایشگاه تشخیص پزشکی, نوبت آنلاین پزشک',
        ogImage: `${SITE_URL}/salamatlab-homepage-preview.jpg`,
    },
    '/about': {
        title: 'درباره ما | آزمایشگاه تشخیص پزشکی سلامت',
        description: 'آشنایی با آزمایشگاه تشخیص پزشکی سلامت: تیم متخصص، فناوری‌های پیشرفته و رویکرد انسان‌محور برای دقیق‌ترین نتایج تشخیصی.',
    },
    '/contact': {
        title: 'تماس با آزمایشگاه سلامت شهرقدس | آدرس و تلفن',
        description: 'راه‌های ارتباطی، آدرس، شماره تماس و اطلاعات مراجعه به آزمایشگاه تشخیص پزشکی سلامت در شهرقدس.',
    },
    '/doctors': {
        title: 'پزشکان شهرقدس | نوبت‌دهی پزشکان آزمایشگاه سلامت',
        description: 'لیست پزشکان عمومی و متخصص شهرقدس در آزمایشگاه سلامت، همراه با امکان نوبت‌دهی و مشاهده تخصص‌ها.',
    },
    '/doctors/shahrqods': {
        title: 'بهترین پزشکان شهرقدس | دکتر خوب در قدس',
        description: 'معرفی پزشکان عمومی و متخصص شهرقدس برای ویزیت، مشاوره و نوبت‌دهی در آزمایشگاه سلامت.',
    },
    '/doctors/urology': {
        title: 'پزشک اورولوژی شهرقدس | بهترین متخصص کلیه و مثانه | آزمایشگاه سلامت',
        description: 'بهترین پزشکان متخصص اورولوژی در شهرقدس. درمان سنگ کلیه، پروستات، عفونت ادراری و مشکلات دستگاه ادراری تناسلی. نوبت آنلاین',
    },
    '/doctors/orthopedic': {
        title: 'پزشک ارتوپدی شهرقدس | متخصص استخوان و مفاصل',
        description: 'معرفی پزشکان متخصص ارتوپدی در شهرقدس برای درد مفاصل، آسیب‌های ورزشی، ستون فقرات و مشکلات استخوانی.',
    },
    '/doctors/gynecology': {
        title: 'پزشک زنان شهرقدس | متخصص زنان و زایمان قدس',
        description: 'معرفی پزشکان متخصص زنان و زایمان در شهرقدس برای مراقبت بارداری، معاینات دوره‌ای و درمان بیماری‌های زنان.',
    },
    '/doctors/general': {
        title: 'پزشک عمومی شهرقدس | بهترین دکتر عمومی قدس | ویزیت آنلاین',
        description: 'بهترین پزشکان عمومی در شهرقدس. ویزیت، معاینه، تشخیص اولیه بیماری‌ها، واکسیناسیون و مشاوره سلامت. نوبت آنلاین و تلفنی',
    },
    '/doctors/internal-medicine': {
        title: 'پزشک داخلی شهرقدس | بهترین متخصص طب داخلی | دکتر داخلی قدس',
        description: 'بهترین پزشکان متخصص داخلی در شهرقدس. تشخیص و درمان دیابت، فشار خون، بیماری‌های کلیوی، گوارشی و اختلالات متابولیک. نوبت آنلاین',
    },
    '/doctors/midwife': {
        title: 'ماما شهرقدس | مراقبت بارداری و سلامت زنان',
        description: 'خدمات مامایی در شهرقدس شامل مراقبت بارداری، مشاوره پیش از بارداری، مراقبت مادر و نوزاد و سلامت زنان.',
    },
    '/doctors/cardiology': {
        title: 'پزشک قلب شهرقدس | بهترین متخصص قلب و عروق | کاردیولوژیست قدس',
        description: 'بهترین پزشکان متخصص قلب و عروق در شهرقدس. تشخیص و درمان بیماری‌های قلبی، فشار خون، آریتمی، اکوکاردیوگرافی و ECG. نوبت آنلاین',
        keywords: 'پزشک قلب شهرقدس, متخصص قلب و عروق شهرقدس, کاردیولوژیست قدس, فشار خون, آریتمی, بیماری قلبی, اکوکاردیوگرافی شهرقدس, ECG قدس, کلسترول',
    },
    '/doctors/pediatric': {
        title: 'پزشک اطفال شهرقدس | بهترین متخصص کودکان | دکتر اطفال قدس',
        description: 'بهترین پزشکان متخصص اطفال در شهرقدس. ویزیت کودکان، واکسیناسیون، پیگیری رشد و تکامل، درمان بیماری‌های کودکان. نوبت آنلاین',
        keywords: 'پزشک اطفال شهرقدس, متخصص کودکان شهرقدس, دکتر اطفال قدس, واکسیناسیون کودک, ویزیت کودک شهرقدس, رشد کودک, بیماری کودکان, متخصص اطفال قدس',
    },
    '/articles': {
        title: 'مقالات علمی سلامت | آزمایشگاه تشخیص پزشکی سلامت',
        description: 'مقالات علمی و آموزشی آزمایشگاه سلامت درباره آزمایش‌ها، بیماری‌ها، پیشگیری و نکات کاربردی سلامت.',
    },
    '/blog': {
        title: 'بلاگ سلامت | آزمایشگاه تشخیص پزشکی سلامت',
        description: 'مقالات و مطالب مفید در زمینه سلامت، آزمایشات پزشکی و اخبار آزمایشگاه سلامت.',
    },
    '/services': {
        title: 'خدمات آزمایشگاه سلامت شهرقدس | آزمایش‌های تشخیص پزشکی',
        description: 'معرفی خدمات آزمایشگاه تشخیص پزشکی سلامت شامل هماتولوژی، بیوشیمی، میکروبیولوژی، ایمونولوژی، سیتولوژی و نمونه‌گیری.',
    },
    '/services/hematology': {
        title: 'آزمایش‌های هماتولوژی | آزمایشگاه سلامت شهرقدس',
        description: 'خدمات هماتولوژی آزمایشگاه سلامت شامل CBC، بررسی کم‌خونی، انعقاد خون و آزمایش‌های تخصصی خون.',
    },
    '/services/biochemistry': {
        title: 'آزمایش‌های بیوشیمی | آزمایشگاه سلامت شهرقدس',
        description: 'آزمایش‌های بیوشیمی خون و ادرار شامل قند، چربی، کبد، کلیه، الکترولیت‌ها و تست‌های تخصصی در شهرقدس.',
    },
    '/services/coagulation': {
        title: 'آزمایش‌های انعقادی | آزمایشگاه سلامت شهرقدس',
        description: 'تست‌های انعقادی شامل PT، PTT، INR، فاکتورهای انعقادی و بررسی اختلالات خونریزی و ترومبوز.',
    },
    '/services/microbiology': {
        title: 'آزمایش‌های میکروبیولوژی | کشت و آنتی‌بیوگرام شهرقدس',
        description: 'خدمات میکروبیولوژی شامل کشت نمونه‌ها، آنتی‌بیوگرام، بررسی عفونت‌ها و تست‌های تخصصی میکروبی.',
    },
    '/services/immunology': {
        title: 'آزمایش‌های ایمونولوژی | آزمایشگاه سلامت شهرقدس',
        description: 'آزمایش‌های ایمونولوژی شامل آنتی‌بادی‌ها، آلرژی، خودایمنی، کمپلمان و تست‌های تخصصی سیستم ایمنی.',
    },
    '/services/cytology': {
        title: 'آزمایش‌های سیتولوژی | پاپ اسمیر و FNA شهرقدس',
        description: 'خدمات سیتولوژی شامل پاپ اسمیر، FNA، بررسی مایعات بدن و تست‌های تخصصی سلولی در آزمایشگاه سلامت.',
    },
    '/services/molecular-diagnosis': {
        title: 'تشخیص مولکولی | آزمایش‌های PCR و ژنتیک',
        description: 'خدمات تشخیص مولکولی آزمایشگاه سلامت شامل PCR، تست‌های ژنتیک، تشخیص عفونت‌ها و آزمایش‌های مولکولی تخصصی.',
    },
    '/services/flow-cytometry': {
        title: 'فلوسایتومتری | آزمایشگاه تشخیص پزشکی سلامت',
        description: 'خدمات فلوسایتومتری برای ایمونوفنوتایپینگ سلولی، بررسی بدخیمی‌های خونی و تست‌های تخصصی سیستم ایمنی.',
    },
    '/services/toxicology': {
        title: 'آزمایش‌های سم‌شناسی | آزمایشگاه سلامت شهرقدس',
        description: 'تست‌های سم‌شناسی، غربالگری داروها و مواد، پایش درمان دارویی و آزمایش‌های تخصصی توکسیکولوژی.',
    },
    '/services/research': {
        title: 'خدمات پژوهشی آزمایشگاهی | آزمایشگاه سلامت',
        description: 'خدمات پژوهشی و تخصصی آزمایشگاه سلامت برای پروژه‌های تحقیقاتی، دانشگاهی و مطالعات بالینی.',
    },
    '/sample-at-home': {
        title: 'نمونه‌گیری در منزل شهرقدس | آزمایشگاه سلامت',
        description: 'درخواست نمونه‌گیری آزمایش در منزل در شهرقدس با تیم حرفه‌ای آزمایشگاه سلامت و دریافت نتایج دقیق.',
    },
    '/checkups/request': {
        title: 'درخواست چکاپ سلامت | آزمایشگاه سلامت شهرقدس',
        description: 'ثبت درخواست چکاپ و آزمایش‌های دوره‌ای سلامت در آزمایشگاه تشخیص پزشکی سلامت شهرقدس.',
        noindex: true,
    },
    '/careers': {
        title: 'همکاری با آزمایشگاه سلامت | فرصت‌های شغلی',
        description: 'ارسال رزومه و درخواست همکاری با آزمایشگاه تشخیص پزشکی سلامت در شهرقدس.',
        noindex: true,
    },
    '/feedback': {
        title: 'نظرسنجی آزمایشگاه سلامت',
        description: 'ثبت نظر و تجربه مراجعه به آزمایشگاه تشخیص پزشکی سلامت برای بهبود کیفیت خدمات.',
        noindex: true,
    },
    '/womens-day': {
        title: 'روز زن | آزمایشگاه سلامت',
        description: 'صفحه کمپین روز زن آزمایشگاه سلامت.',
        noindex: true,
    },
    '/services-landing': {
        title: 'خدمات آزمایشگاهی سلامت',
        description: 'صفحه فرود خدمات آزمایشگاه سلامت.',
        noindex: true,
    },
};
export const normalizeSeoPath = (path: string): string => path === '' ? '/' : path.replace(/\/$/, '') || '/';
export const isSystemNoindexPath = (path: string): boolean => SYSTEM_NOINDEX_PATTERNS.some((pattern) => pattern.test(path));
export const isEmptyCategoryPath = (path: string): boolean => EMPTY_CATEGORY_PATHS.includes(path);
export const shouldNoindexPath = (path: string, entryNoindex = false): boolean => entryNoindex || isSystemNoindexPath(path) || isEmptyCategoryPath(path);
export const buildCanonicalUrl = (path: string): string => `${SITE_URL}${normalizeSeoPath(path)}`;
export const getSeoEntry = (path: string): SeoEntry => {
    const normalizedPath = normalizeSeoPath(path);
    if (entries[normalizedPath]) {
        const entry = entries[normalizedPath];
        return {
            ...entry,
            noindex: shouldNoindexPath(normalizedPath, entry.noindex),
        };
    }
    if (normalizedPath.startsWith('/blog/')) {
        return {
            title: 'مقاله بلاگ سلامت | آزمایشگاه تشخیص پزشکی سلامت',
            description: 'مطالعه مقاله بلاگ آزمایشگاه سلامت درباره سلامت، آزمایش‌های پزشکی و مراقبت‌های پیشگیرانه.',
        };
    }
    if (normalizedPath.startsWith('/article/') || normalizedPath.startsWith('/articles/')) {
        return {
            title: 'مقاله علمی | آزمایشگاه تشخیص پزشکی سلامت',
            description: 'مطالعه مقاله علمی آزمایشگاه سلامت درباره تشخیص پزشکی، آزمایش‌ها و مراقبت سلامت.',
        };
    }
    if (normalizedPath.startsWith('/admin') || normalizedPath.startsWith('/r/') || normalizedPath === '/game') {
        return {
            title: 'صفحه داخلی | آزمایشگاه سلامت',
            description: 'صفحه داخلی آزمایشگاه سلامت.',
            noindex: true,
        };
    }
    return {
        title: 'آزمایشگاه تشخیص پزشکی سلامت',
        description: 'آزمایشگاه تشخیص پزشکی سلامت پیشرو در ارائه خدمات تشخیص پزشکی با بالاترین کیفیت و دقت در شهرقدس.',
        noindex: shouldNoindexPath(normalizedPath),
    };
};

type PrerenderArticle = {
    title: string;
    excerpt: string;
    slug: string;
    category?: string;
};

type PrerenderStore = {
    articleBySlug?: {
        [slug: string]: {
            title: string;
            excerpt: string;
            slug: string;
            category?: string;
        };
    };
    allArticles?: {
        articles: Array<{
            title: string;
            excerpt: string;
            slug: string;
            category?: string;
        }>;
    };
};

export const getPrerenderedArticleBySlug = (path: string): PrerenderArticle | null => {
    const match = path.match(/^\/articles\/([^/?#]+)\/?$/);
    if (!match) {
        return null;
    }
    const slug = decodeURIComponent(match[1]);
    const store = (globalThis as { __SALAMAT_PRERENDER__?: PrerenderStore }).__SALAMAT_PRERENDER__;
    const articleFromList = store?.allArticles?.articles?.find((entry) => entry.slug === slug);
    const articleFromSlug = store?.articleBySlug?.[slug];
    const source = articleFromSlug || articleFromList;
    if (!source) {
        return null;
    }
    return {
        title: source.title,
        excerpt: source.excerpt,
        slug: source.slug,
        category: source.category,
    };
};

const getFallbackArticleMetadata = (path: string) => {
    const normalizedPath = normalizeSeoPath(path);
    if (!normalizedPath.startsWith('/articles/')) {
        return null;
    }
    return {
        title: 'مقاله علمی | آزمایشگاه تشخیص پزشکی سلامت',
        description: 'مطالعه مقاله علمی آزمایشگاه سلامت درباره تشخیص پزشکی، آزمایش‌ها و مراقبت سلامت.',
    };
};
export const createSeoHead = (path: string): string => {
    const seo = getSeoEntry(path);
    const normalizedPath = normalizeSeoPath(path);
    const canonical = buildCanonicalUrl(normalizedPath);
    const noindex = shouldNoindexPath(normalizedPath, seo.noindex);
    const article = getPrerenderedArticleBySlug(normalizedPath);
    const fallbackArticle = getFallbackArticleMetadata(normalizedPath);
    const title = article?.title || (fallbackArticle ? fallbackArticle.title : seo.title);
    const description = article?.excerpt || (fallbackArticle ? fallbackArticle.description : seo.description);
    const ogImage = seo.ogImage || DEFAULT_OG_IMAGE;
    return [
        `<title>${escapeHtml(title)}</title>`,
        `<meta name="description" content="${escapeHtml(description)}" />`,
        seo.keywords ? `<meta name="keywords" content="${escapeHtml(seo.keywords)}" />` : '',
        noindex ? '<meta name="robots" content="noindex, nofollow" />' : '<meta name="robots" content="index, follow" />',
        noindex ? '' : `<link rel="canonical" href="${canonical}" />`,
        `<meta property="og:title" content="${escapeHtml(title)}" />`,
        `<meta property="og:description" content="${escapeHtml(description)}" />`,
        '<meta property="og:type" content="website" />',
        `<meta property="og:image" content="${ogImage}" />`,
        `<meta property="og:url" content="${canonical}" />`,
        '<meta property="og:site_name" content="آزمایشگاه تشخیص پزشکی سلامت" />',
        '<meta name="twitter:card" content="summary_large_image" />',
        `<meta name="twitter:title" content="${escapeHtml(title)}" />`,
        `<meta name="twitter:description" content="${escapeHtml(description)}" />`,
        `<meta name="twitter:image" content="${ogImage}" />`,
    ].filter(Boolean).join('\n    ');
};
const escapeHtml = (value: string): string => value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
